export const IN_PROD = process.env.NEXT_PUBLIC_ENV === 'prod';

export const MATCH_OPTIONS = [
    {
        value: 'any',
        label: 'Any',
    },
    {
        value: 'busy',
        label: 'Busy',
    },
    {
        value: 'free',
        label: 'Free',
    },
];

export const PERIOD_OPTIONS = [
    {
        value: 'minutes',
        label: 'Minutes',
    },
    {
        value: 'hours',
        label: 'Hours',
    },
    {
        value: 'days',
        label: 'Days',
    },
    {
        value: 'weeks',
        label: 'Weeks',
    },
];

export const WHEN_OPTIONS = [
    {
        value: 'before_start',
        label: 'Before Start',
    },
    {
        value: 'after_start',
        label: 'After Start',
    },
    {
        value: 'before_end',
        label: 'Before End',
    },
    {
        value: 'after_end',
        label: 'After End',
    },
    {
        value: 'time_to_leave',
        label: 'Time to Leave',
        block_others: true,
    },
];

export const CHANNEL_OPTIONS = IN_PROD
    ? [
        { label: 'Calendar Popup', value: 'popup' },
        { label: 'Email Me', value: 'email' },
    ] : [
        { label: 'App (In Your Face)', value: 'alert_high' },
        { label: 'App (Mild)', value: 'alert_low' },
        { label: 'App (Severe)', value: 'alert_medium' },
        { label: 'Calendar Popup', value: 'popup' },
        { label: 'Call Me', value: 'call' },
        { label: 'Email Me', value: 'email' },
        { label: 'Text Me', value: 'text' },
    ];

export const VENUE_OPTIONS = [
    { label: 'Bar', value: 'bar' },
    { label: 'Cafe', value: 'cafe' },
    { label: 'Call (Video)', value: 'video' },
    { label: 'Call (Voice)', value: 'call' },
    { label: 'Home', value: 'home' },
    { label: 'Meeting Room', value: 'meeting_room' },
    { label: 'Not Important', value: 'not_important' },
    { label: 'Office', value: 'office' },
    { label: 'Restaurant', value: 'restaurant' },
    { label: 'Somewhere Quiet', value: 'somewhere_quiet' },
    { label: 'Traveling', value: 'traveling' },
    { label: 'Unavailable', value: 'unavailable' },
];

export const PRIORITY_OPTIONS = ['1', '2', '3', '4', '5'];

export const DEFAULT_PRIORITY = 2;

export const CALENDAR_CATEGORIES_OPTIONS = [
    {
        value: 'professional',
        label: 'Professional',
    },
    {
        value: 'personal',
        label: 'Personal',
    },
    {
        value: 'third_party',
        label: '3rd Party',
    },
    {
        value: 'resource',
        label: 'Resource',
    },
    {
        value: 'travel',
        label: 'Travel',
    },
    {
        value: 'ooo',
        label: 'Out of Office',
    },
    {
        value: 'other',
        label: 'Other',
    },
];

export const LOCATION_OPTIONS = [
    {
        value: 'address',
        label: 'Address',
    },
    {
        value: 'phone',
        label: 'Phone',
    },
    {
        value: 'video',
        label: 'Video Call',
    },
];

export const NPS_SURVEY_RECIPIENTS_OPTIONS = [
    {
        value: 'internal',
        label: 'Internal',
    },
    {
        value: 'no_vips',
        label: 'No VIPs',
    },
    {
        value: 'everyone',
        label: 'Everyone',
    },
];

export const NPS_SURVEY_FREQUENCY_OPTIONS = [
    {
        value: 'light',
        label: 'Light',
    },
    {
        value: 'medium',
        label: 'Medium',
    },
    {
        value: 'heavy',
        label: 'Heavy',
    },
];

export const REMINDER_OPTIONS = [
    {
        value: 'prior_day',
        label: 'Day Before',
    },
    {
        value: 'prior_hour',
        label: 'Hour Before',
    },
    {
        value: 'both',
        label: 'Both',
    },
];

export const UPDATED_SUCCESSFULLY_MESSAGE = 'Alert updated successfully.';
